<template>
  <div class="common-dialog">
    <el-dialog v-bind="$attrs">
      <slot></slot>
      <slot name="footer"></slot>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    dialogData() {
      this.$emit("onChange", this.$attrs.visible);
      return {
        width: "720px",
        visible: false,
        ...this.$attrs,
      };
    },
  },
  methods: {
    handleClose() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.common-dialog {
  /deep/.el-dialog {
    padding: 20px 20px;
    .el-dialog__title {
      font-family: "PingFang HK";
      font-weight: 600;
      font-size: 20px;
      color: #030229;
    }
    // .el-dialog__headerbtn {
    //   top: 40px;
    //   right: 40px;
    //   width: 40px;
    //   height: 40px;
    //   border-radius: 50%;
    //   background: rgba(231, 29, 54, 0.05);
    //   .el-dialog__close {
    //     color: #e71d36;
    //   }
    // }
  }
}
</style>
